import { Loader } from '../../Loader'
import { Mask } from '../../Mask'

import * as styles from './ModalLoader.module.css'

function ModalLoader({ className = styles.ModalLoaderMask }) {
  return (
    <Mask className={className}>
      <Loader className={styles.modalLoader} />
    </Mask>
  )
}

export default ModalLoader
